import script from "./ProjectDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetail.vue?vue&type=style&index=0&id=86575262&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86575262"]])

export default __exports__